export default __webpack_public_path__ + "images/248d7e11d9885236625a1b207adf62c6-4_tablet_1067x470.jpg";